import axios from "axios";

const state = {
  locations: [],
  selectedLocation: null,
  selectedLocationName: null,
};

const mutations = {
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
  SET_SELECTED_LOCATION(state, locationId) {
    state.selectedLocation = locationId;
  },
  SET_SELECTED_LOCATION_NAME(state, name) {
    state.selectedLocationName = name;
  },
};

const actions = {
  async fetchLocations({ commit }) {
    return axios.get("/api/locations").then((response) => {
      console.log('fetchLocations response:', response);
      const locations = response.data.data;
      commit("SET_LOCATIONS", locations);
    });
  },
  selectLocation({ commit }, locationId) {
    commit("SET_SELECTED_LOCATION", locationId);
  },
  selectLocationName({ commit }, name) {
    commit("SET_SELECTED_LOCATION_NAME", name);
  },
};

const getters = {
  locations: (state) => state.locations,
  selectedLocation: (state) => state.selectedLocation,
  selectedLocationName: (state) => state.selectedLocationName,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
